// source: subscription_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var timestamp_proto_pb = require('./timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.DataUsage', null, global);
goog.exportSymbol('proto.DataUsageRecord', null, global);
goog.exportSymbol('proto.SubscriptionRecord', null, global);
goog.exportSymbol('proto.SubscriptionRecord.Status', null, global);
goog.exportSymbol('proto.SubscriptionRequest', null, global);
goog.exportSymbol('proto.SubscriptionRequest.Plan', null, global);
goog.exportSymbol('proto.SubscriptionRequest.Status', null, global);
goog.exportSymbol('proto.SubscriptionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SubscriptionRequest.displayName = 'proto.SubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SubscriptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.SubscriptionResponse.repeatedFields_, null);
};
goog.inherits(proto.SubscriptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SubscriptionResponse.displayName = 'proto.SubscriptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DataUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DataUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DataUsage.displayName = 'proto.DataUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DataUsageRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DataUsageRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DataUsageRecord.displayName = 'proto.DataUsageRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.SubscriptionRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.SubscriptionRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.SubscriptionRecord.displayName = 'proto.SubscriptionRecord';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.SubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
plan: jspb.Message.getFieldWithDefault(msg, 2, 0),
startDate: (f = msg.getStartDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
endDate: (f = msg.getEndDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
currentPeriodStartDate: (f = msg.getCurrentPeriodStartDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
currentPeriodEndDate: (f = msg.getCurrentPeriodEndDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
deviceSerial: jspb.Message.getFieldWithDefault(msg, 8, ""),
pendingSubscription: (f = msg.getPendingSubscription()) && proto.SubscriptionRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SubscriptionRequest}
 */
proto.SubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SubscriptionRequest;
  return proto.SubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SubscriptionRequest}
 */
proto.SubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionCode(value);
      break;
    case 2:
      var value = /** @type {!proto.SubscriptionRequest.Plan} */ (reader.readEnum());
      msg.setPlan(value);
      break;
    case 3:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 4:
      var value = /** @type {!proto.SubscriptionRequest.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 6:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCurrentPeriodStartDate(value);
      break;
    case 7:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCurrentPeriodEndDate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceSerial(value);
      break;
    case 9:
      var value = new proto.SubscriptionRequest;
      reader.readMessage(value,proto.SubscriptionRequest.deserializeBinaryFromReader);
      msg.setPendingSubscription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlan();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCurrentPeriodStartDate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCurrentPeriodEndDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeviceSerial();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPendingSubscription();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.SubscriptionRequest.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.SubscriptionRequest.Status = {
  CANCELED: 0,
  EXPIRED: 1,
  ACTIVE: 2
};

/**
 * @enum {number}
 */
proto.SubscriptionRequest.Plan = {
  NONE: 0,
  PLAN1M: 1,
  PLAN1Y: 2,
  PLAN2M: 3,
  PLAN2Y: 4,
  PLAN3M: 5,
  PLAN3Y: 6,
  PLAN4Y: 7,
  PLAN5M: 9,
  PLAN5Y: 10,
  PLAN6Y: 11,
  PLAN6M: 12,
  DEMO: 13,
  PLAN7M: 14,
  PLAN7Y: 15,
  PLAN6MP: 16,
  PLAN6YP: 17,
  PLAN7MP: 18,
  PLAN7YP: 19
};

/**
 * optional string subscription_code = 1;
 * @return {string}
 */
proto.SubscriptionRequest.prototype.getSubscriptionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.setSubscriptionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Plan plan = 2;
 * @return {!proto.SubscriptionRequest.Plan}
 */
proto.SubscriptionRequest.prototype.getPlan = function() {
  return /** @type {!proto.SubscriptionRequest.Plan} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SubscriptionRequest.Plan} value
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.setPlan = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Timestamp start_date = 3;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRequest.prototype.getStartDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 3));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRequest} returns this
*/
proto.SubscriptionRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Status status = 4;
 * @return {!proto.SubscriptionRequest.Status}
 */
proto.SubscriptionRequest.prototype.getStatus = function() {
  return /** @type {!proto.SubscriptionRequest.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SubscriptionRequest.Status} value
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Timestamp end_date = 5;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRequest.prototype.getEndDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 5));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRequest} returns this
*/
proto.SubscriptionRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Timestamp current_period_start_date = 6;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRequest.prototype.getCurrentPeriodStartDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 6));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRequest} returns this
*/
proto.SubscriptionRequest.prototype.setCurrentPeriodStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.clearCurrentPeriodStartDate = function() {
  return this.setCurrentPeriodStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRequest.prototype.hasCurrentPeriodStartDate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Timestamp current_period_end_date = 7;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRequest.prototype.getCurrentPeriodEndDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 7));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRequest} returns this
*/
proto.SubscriptionRequest.prototype.setCurrentPeriodEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.clearCurrentPeriodEndDate = function() {
  return this.setCurrentPeriodEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRequest.prototype.hasCurrentPeriodEndDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string device_serial = 8;
 * @return {string}
 */
proto.SubscriptionRequest.prototype.getDeviceSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.setDeviceSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional SubscriptionRequest pending_subscription = 9;
 * @return {?proto.SubscriptionRequest}
 */
proto.SubscriptionRequest.prototype.getPendingSubscription = function() {
  return /** @type{?proto.SubscriptionRequest} */ (
    jspb.Message.getWrapperField(this, proto.SubscriptionRequest, 9));
};


/**
 * @param {?proto.SubscriptionRequest|undefined} value
 * @return {!proto.SubscriptionRequest} returns this
*/
proto.SubscriptionRequest.prototype.setPendingSubscription = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRequest} returns this
 */
proto.SubscriptionRequest.prototype.clearPendingSubscription = function() {
  return this.setPendingSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRequest.prototype.hasPendingSubscription = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.SubscriptionResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.SubscriptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionsList: jspb.Message.toObjectList(msg.getSubscriptionsList(),
    proto.SubscriptionRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SubscriptionResponse}
 */
proto.SubscriptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SubscriptionResponse;
  return proto.SubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SubscriptionResponse}
 */
proto.SubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.SubscriptionRequest;
      reader.readMessage(value,proto.SubscriptionRequest.deserializeBinaryFromReader);
      msg.addSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SubscriptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SubscriptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.SubscriptionRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionRequest subscriptions = 1;
 * @return {!Array<!proto.SubscriptionRequest>}
 */
proto.SubscriptionResponse.prototype.getSubscriptionsList = function() {
  return /** @type{!Array<!proto.SubscriptionRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.SubscriptionRequest, 1));
};


/**
 * @param {!Array<!proto.SubscriptionRequest>} value
 * @return {!proto.SubscriptionResponse} returns this
*/
proto.SubscriptionResponse.prototype.setSubscriptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.SubscriptionRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.SubscriptionRequest}
 */
proto.SubscriptionResponse.prototype.addSubscriptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.SubscriptionRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SubscriptionResponse} returns this
 */
proto.SubscriptionResponse.prototype.clearSubscriptionsList = function() {
  return this.setSubscriptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DataUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.DataUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DataUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
bytes: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DataUsage}
 */
proto.DataUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DataUsage;
  return proto.DataUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DataUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DataUsage}
 */
proto.DataUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBytes(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DataUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DataUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DataUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBytes();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional uint32 bytes = 1;
 * @return {number}
 */
proto.DataUsage.prototype.getBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.DataUsage} returns this
 */
proto.DataUsage.prototype.setBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.DataUsage.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.DataUsage} returns this
 */
proto.DataUsage.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DataUsageRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.DataUsageRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DataUsageRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataUsageRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
subscription: (f = msg.getSubscription()) && proto.SubscriptionRecord.toObject(includeInstance, f),
dataUsage: (f = msg.getDataUsage()) && proto.DataUsage.toObject(includeInstance, f),
serial: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DataUsageRecord}
 */
proto.DataUsageRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DataUsageRecord;
  return proto.DataUsageRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DataUsageRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DataUsageRecord}
 */
proto.DataUsageRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.SubscriptionRecord;
      reader.readMessage(value,proto.SubscriptionRecord.deserializeBinaryFromReader);
      msg.setSubscription(value);
      break;
    case 2:
      var value = new proto.DataUsage;
      reader.readMessage(value,proto.DataUsage.deserializeBinaryFromReader);
      msg.setDataUsage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DataUsageRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DataUsageRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DataUsageRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataUsageRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscription();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.SubscriptionRecord.serializeBinaryToWriter
    );
  }
  f = message.getDataUsage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.DataUsage.serializeBinaryToWriter
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional SubscriptionRecord subscription = 1;
 * @return {?proto.SubscriptionRecord}
 */
proto.DataUsageRecord.prototype.getSubscription = function() {
  return /** @type{?proto.SubscriptionRecord} */ (
    jspb.Message.getWrapperField(this, proto.SubscriptionRecord, 1));
};


/**
 * @param {?proto.SubscriptionRecord|undefined} value
 * @return {!proto.DataUsageRecord} returns this
*/
proto.DataUsageRecord.prototype.setSubscription = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DataUsageRecord} returns this
 */
proto.DataUsageRecord.prototype.clearSubscription = function() {
  return this.setSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DataUsageRecord.prototype.hasSubscription = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DataUsage data_usage = 2;
 * @return {?proto.DataUsage}
 */
proto.DataUsageRecord.prototype.getDataUsage = function() {
  return /** @type{?proto.DataUsage} */ (
    jspb.Message.getWrapperField(this, proto.DataUsage, 2));
};


/**
 * @param {?proto.DataUsage|undefined} value
 * @return {!proto.DataUsageRecord} returns this
*/
proto.DataUsageRecord.prototype.setDataUsage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.DataUsageRecord} returns this
 */
proto.DataUsageRecord.prototype.clearDataUsage = function() {
  return this.setDataUsage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.DataUsageRecord.prototype.hasDataUsage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string serial = 3;
 * @return {string}
 */
proto.DataUsageRecord.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.DataUsageRecord} returns this
 */
proto.DataUsageRecord.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.SubscriptionRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.SubscriptionRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SubscriptionRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
subscriptionCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
plan: jspb.Message.getFieldWithDefault(msg, 4, 0),
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
organizationId: jspb.Message.getFieldWithDefault(msg, 6, ""),
startDate: (f = msg.getStartDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
billDate: (f = msg.getBillDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
monthlyBillDate: (f = msg.getMonthlyBillDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
reportDate: (f = msg.getReportDate()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SubscriptionRecord}
 */
proto.SubscriptionRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.SubscriptionRecord;
  return proto.SubscriptionRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SubscriptionRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SubscriptionRecord}
 */
proto.SubscriptionRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionCode(value);
      break;
    case 4:
      var value = /** @type {!proto.SubscriptionRequest.Plan} */ (reader.readEnum());
      msg.setPlan(value);
      break;
    case 5:
      var value = /** @type {!proto.SubscriptionRecord.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizationId(value);
      break;
    case 7:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 8:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 9:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBillDate(value);
      break;
    case 10:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setMonthlyBillDate(value);
      break;
    case 11:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReportDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.SubscriptionRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.SubscriptionRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SubscriptionRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.SubscriptionRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlan();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getOrganizationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBillDate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMonthlyBillDate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReportDate();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.SubscriptionRecord.Status = {
  NONE: 0,
  CANCELED: 1,
  EXPIRED: 2,
  ACTIVE: 3
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.SubscriptionRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.SubscriptionRecord.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subscription_code = 3;
 * @return {string}
 */
proto.SubscriptionRecord.prototype.getSubscriptionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.setSubscriptionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SubscriptionRequest.Plan plan = 4;
 * @return {!proto.SubscriptionRequest.Plan}
 */
proto.SubscriptionRecord.prototype.getPlan = function() {
  return /** @type {!proto.SubscriptionRequest.Plan} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SubscriptionRequest.Plan} value
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.setPlan = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Status status = 5;
 * @return {!proto.SubscriptionRecord.Status}
 */
proto.SubscriptionRecord.prototype.getStatus = function() {
  return /** @type {!proto.SubscriptionRecord.Status} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.SubscriptionRecord.Status} value
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string organization_id = 6;
 * @return {string}
 */
proto.SubscriptionRecord.prototype.getOrganizationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.setOrganizationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Timestamp start_date = 7;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRecord.prototype.getStartDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 7));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRecord} returns this
*/
proto.SubscriptionRecord.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRecord.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Timestamp end_date = 8;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRecord.prototype.getEndDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 8));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRecord} returns this
*/
proto.SubscriptionRecord.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRecord.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Timestamp bill_date = 9;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRecord.prototype.getBillDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 9));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRecord} returns this
*/
proto.SubscriptionRecord.prototype.setBillDate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.clearBillDate = function() {
  return this.setBillDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRecord.prototype.hasBillDate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Timestamp monthly_bill_date = 10;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRecord.prototype.getMonthlyBillDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 10));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRecord} returns this
*/
proto.SubscriptionRecord.prototype.setMonthlyBillDate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.clearMonthlyBillDate = function() {
  return this.setMonthlyBillDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRecord.prototype.hasMonthlyBillDate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Timestamp report_date = 11;
 * @return {?proto.Timestamp}
 */
proto.SubscriptionRecord.prototype.getReportDate = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 11));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.SubscriptionRecord} returns this
*/
proto.SubscriptionRecord.prototype.setReportDate = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.SubscriptionRecord} returns this
 */
proto.SubscriptionRecord.prototype.clearReportDate = function() {
  return this.setReportDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.SubscriptionRecord.prototype.hasReportDate = function() {
  return jspb.Message.getField(this, 11) != null;
};


goog.object.extend(exports, proto);
